import React from "react";
import styled from "styled-components";
import logo from "../assets/img/logoXL.png";

const LogoImage = styled.img`
  max-width: 100px;
  margin-bottom: 2rem;
`;

const Logo: React.FC = () => {
  return <LogoImage src={logo} alt="Logo" />;
};

export default Logo;
